module.exports = __webpack_public_path__ + "static/img/4-1-1.4ff0d73f.jpg";